// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMWidget.tsx — PropelMapper dashboard widget (the card shell of the bento board).
//
// A widget is a PMCard-style surface with an eyebrow (icon + title + count + right
// link) and a body, plus — in customize mode — a handle cluster (resize / drag /
// hide). A widget can declare A/B *layout variants* (e.g. Tasks as Checklist vs.
// Progress ring); the active variant's body renders and the variant list feeds the
// board's "widget gallery". Pinned widgets show a lock badge instead of handles.
//
// PMWidget is presentational — PMWidgetBoard owns order/span/variant/hidden state,
// persistence, and the gallery, and injects the customize props + drag handlers.
// Icons come from the custom set via window.PM_ICONS (load assets/icons/icon-data.js).
//
//   <PMWidget widgetId="tasks" title="Tasks assigned to me" icon="check-circle" count={2}
//     variants={[
//       { id:"a", label:"Checklist", icon:"clipboard", render:() => <Checklist/> },
//       { id:"b", label:"Progress",  icon:"bar-chart", render:() => <Ring/> },
//     ]} />

const PMWIDGET_CSS = `
.pmw{position:relative;box-sizing:border-box;background:var(--pm-surface);border:1px solid var(--pm-border-card);border-radius:var(--pm-radius-xl,18px);box-shadow:var(--pm-shadow-card);padding:18px;font-family:var(--pm-font-sans)}
.pmw *{box-sizing:border-box}
.pmw.span2{grid-column:1 / -1}
.pmw-eyebrow{display:flex;align-items:center;gap:8px;margin:0 0 14px;font:var(--pm-section);font-weight:700;letter-spacing:.05em;text-transform:uppercase;color:var(--pm-fg-1)}
.pmw-eyebrow .pmw-ico{display:inline-flex;width:18px;height:18px;color:var(--pm-primary);flex:0 0 18px}
.pmw-eyebrow .pmw-ico svg{display:block;width:100%;height:100%}
.pmw-title{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.pmw-count{font:var(--pm-pill);background:var(--pm-surface-variant);color:var(--pm-fg-2);border-radius:var(--pm-radius-pill);padding:2px 8px;flex:0 0 auto}
.pmw-link{margin-left:auto;display:inline-flex;align-items:center;gap:3px;font-size:12px;font-weight:600;color:var(--pm-primary);text-transform:none;letter-spacing:0;cursor:pointer;background:none;border:none;font-family:inherit}
.pmw-link:hover{color:var(--pm-primary-dark)}
.pmw-link .pmw-ico{width:15px;height:15px;color:currentColor}
.pmw-body{min-width:0}

/* customize handle cluster */
.pmw-handles{position:absolute;top:10px;right:10px;display:flex;gap:5px;z-index:3}
.pmw-handle{width:26px;height:26px;border-radius:var(--pm-radius-s,6px);background:var(--pm-surface);border:1px solid var(--pm-border);display:grid;place-items:center;color:var(--pm-fg-2);cursor:pointer;padding:0}
.pmw-handle:hover{color:var(--pm-fg-1);border-color:var(--pm-border-dark)}
.pmw-handle.drag{cursor:grab}
.pmw-handle.drag:active{cursor:grabbing}
.pmw-handle.rm:hover{color:var(--pm-accent-critical,#dc2626);border-color:var(--pm-accent-critical,#dc2626)}
.pmw-handle:focus-visible{outline:none;box-shadow:var(--pm-focus-ring)}
.pmw-handle .pmw-ico{width:16px;height:16px}
.pmw-handle .pmw-ico svg{display:block;width:100%;height:100%}
.pmw-pinlock{position:absolute;top:10px;right:10px;display:inline-flex;align-items:center;gap:5px;z-index:3;font:var(--pm-label-s);font-weight:600;text-transform:uppercase;letter-spacing:.04em;color:var(--pm-fg-3);background:var(--pm-surface);border:1px solid var(--pm-border);border-radius:var(--pm-radius-pill);padding:3px 10px 3px 7px}
.pmw-pinlock .pmw-ico{width:15px;height:15px;color:var(--pm-fg-3)}
.pmw-pinlock .pmw-ico svg{display:block;width:100%;height:100%}
.pmw.is-dragging{opacity:.6;box-shadow:var(--pm-shadow-xl,0 18px 40px rgba(0,0,0,.18));cursor:grabbing}
`;

function pmwEnsureCSS() {
  if (typeof document === "undefined" || document.getElementById("pmwidget-css")) return;
  const s = document.createElement("style"); s.id = "pmwidget-css"; s.textContent = PMWIDGET_CSS;
  document.head.appendChild(s);
}

// Custom-icon glyph (window.PM_ICONS), tinted to currentColor. Resolves the set's
// convention: bare name, then -outline, then -filled (matches PMSidebar). Falls
// back to a typographic glyph for names with no icon in the set yet.
function pmwResolve(name: any) {
  if (!name) return null;
  const I = (typeof window !== "undefined" && (window as any).PM_ICONS) || {};
  return I[name] || I[name + "-outline"] || I[name + "-filled"] || null;
}
function PMWIco({ name, fallback = "" }: any) {
  const svg = pmwResolve(name);
  if (svg) {
    return <span className="pmw-ico" aria-hidden="true" style={{ ["--icon-fg" as any]: "currentColor" }} dangerouslySetInnerHTML={{ __html: svg }} />;
  }
  if (fallback) return <span className="pmw-ico" aria-hidden="true" style={{ fontWeight: 700 }}>{fallback}</span>;
  return null;
}

function PMWHandleIco({ name, fallback }: any) {
  const svg = pmwResolve(name);
  if (svg) return <span className="pmw-ico" aria-hidden="true" style={{ ["--icon-fg" as any]: "currentColor" }} dangerouslySetInnerHTML={{ __html: svg }} />;
  return <span className="pmw-ico" aria-hidden="true" style={{ fontWeight: 700, fontSize: 14, lineHeight: 1 }}>{fallback}</span>;
}

export function PMWidget({
  widgetId,
  title,
  icon,
  count,
  headerLink = null,
  span = 1,
  variant,
  variants = null,
  pinned = false,
  adminOnly = false,
  customizing = false,
  onHide,
  onResize,
  dragHandleProps = null,
  children = null,
  showEyebrow = true,
  className = "",
  style = {},
  ...rest
}: any) {
  pmwEnsureCSS();

  const activeId = variant || (variants && variants[0] && variants[0].id) || "a";
  let body = children;
  if (variants && variants.length) {
    const v = variants.find((x: any) => x.id === activeId) || variants[0];
    body = v && typeof v.render === "function" ? v.render() : (v && v.body) || children;
  }

  return (
    <section
      className={"pmw" + (span === 2 ? " span2" : "") + (className ? " " + className : "")}
      data-widget={widgetId}
      data-variant={activeId}
      style={style}
      {...rest}
    >
      {customizing && pinned ? (
        <span className="pmw-pinlock" title="Pinned — can't be moved or hidden">
          <PMWHandleIco name="lock" fallback="•" />Pinned
        </span>
      ) : null}

      {customizing && !pinned ? (
        <div className="pmw-handles">
          {onResize ? (
            <button type="button" className="pmw-handle sz" title={span === 2 ? "Make narrow" : "Make wide"} onClick={() => onResize(span === 2 ? 1 : 2)}>
              <PMWHandleIco name="expand" fallback="\u2922" />
            </button>
          ) : null}
          <button type="button" className="pmw-handle drag" title="Drag to reorder" aria-label="Drag to reorder" {...(dragHandleProps || {})}>
            <PMWHandleIco name="menu" fallback="\u2630" />
          </button>
          {onHide ? (
            <button type="button" className="pmw-handle rm" title="Hide widget" aria-label="Hide widget" onClick={() => onHide()}>
              <PMWHandleIco name="close" fallback="✕" />
            </button>
          ) : null}
        </div>
      ) : null}

      {showEyebrow && (title || icon) ? (
        <div className="pmw-eyebrow">
          {icon ? <PMWIco name={icon} /> : null}
          <span className="pmw-title">{title}</span>
          {count != null ? <span className="pmw-count">{count}</span> : null}
          {headerLink ? (
            <button type="button" className="pmw-link" onClick={headerLink.onClick}>
              {headerLink.label}
              <PMWIco name={headerLink.icon || "chevron-right"} fallback="›" />
            </button>
          ) : null}
        </div>
      ) : null}

      <div className="pmw-body">{body}</div>
    </section>
  );
}
